export const adjustWhiteBalance = `
vec3 adjustWhiteBalance(vec3 color, int value, float r, float g, float b) {
    if (value == 1) {
        color.r *= r;
        color.g *= g;
        color.b *= b;
    }
    return color;
}
`;
